export const LOAD_FACILITIES_STARTED = "LOAD_FACILITIES_STARTED";
export const LOAD_FACILITIES_SUCCEEDED = "LOAD_FACILITIES_SUCCEEDED";
export const LOAD_FACILITIES_FAILED = "LOAD_FACILITIES_FAILED";
